import React from "react";
import { AlertTriangle, Droplets, Sparkles, GlassWater } from "lucide-react";

const STEP_ICONS = [Droplets, Sparkles, GlassWater];

export const UsageSteps = ({ steps = [], note = "", criticalWarning = "", title = "How to Enjoy" }) => {
    if (!steps.length) return null;
    return (
        <div data-testid="usage-steps">
            <div className="grid sm:grid-cols-3 gap-4">
                {steps.map((s, i) => {
                    const Icon = STEP_ICONS[i % STEP_ICONS.length];
                    return (
                        <div key={s.label || i} className="relative border border-white/10 bg-bg1 p-5 overflow-hidden group hover:border-lime/30 transition-colors">
                            <div className="absolute -right-3 -top-4 font-display text-6xl text-white/[0.04] group-hover:text-lime/10 transition-colors">
                                {s.label || String(i + 1).padStart(2, "0")}
                            </div>
                            <Icon className="w-5 h-5 text-lime" />
                            <div className="mt-4 font-display text-xl uppercase tracking-tight">{s.title}</div>
                            <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{s.body}</p>
                        </div>
                    );
                })}
            </div>

            {criticalWarning && (
                <div className="mt-5 flex items-start gap-3 border border-red-500/40 bg-red-500/[0.07] px-4 py-3.5"
                    data-testid="critical-warning">
                    <AlertTriangle className="w-4 h-4 text-red-400 mt-0.5 shrink-0" />
                    <span className="text-sm uppercase tracking-[0.12em] font-bold text-red-300">{criticalWarning}</span>
                </div>
            )}
            {note && <p className="mt-4 text-sm text-zinc-500 leading-relaxed" data-testid="usage-note">{note}</p>}
        </div>
    );
};

export default UsageSteps;
